module.exports = __webpack_public_path__ + "media/1.ee845ad0.mp3";